module.exports = __webpack_public_path__ + "static/img/dog.cd285a40.png";